<div class="cm-overlay" *ngIf="contact" (click)="close()">
    <div class="cm-modal" (click)="$event.stopPropagation()">
        <button type="button" class="cm-close" (click)="close()"><i class="fa-solid fa-xmark"></i></button>

        <!-- Hamburger menu -->
        <div class="cm-menu-wrap">
            <button type="button" class="cm-menu-btn" (click)="menuOpen = !menuOpen; $event.stopPropagation()"><i class="fa-solid fa-ellipsis-vertical"></i></button>
            <div class="cm-menu-dropdown" *ngIf="menuOpen" (click)="$event.stopPropagation()">
                <button (click)="startEdit(); menuOpen = false"><i class="fa-solid fa-pen"></i> Edit Contact</button>
                <button (click)="openComposer(); menuOpen = false"><i class="fa-solid fa-pen-nib"></i> Draft Intro Email</button>
                <button [disabled]="busy" (click)="verifyEmail(); menuOpen = false"><i class="fa-solid fa-circle-check"></i> Verify Email</button>
                <button [disabled]="busy" (click)="findEmail(); menuOpen = false"><i class="fa-solid fa-magnifying-glass"></i> Find Email</button>
                <button [disabled]="busy" (click)="scrapeLinkedIn(); menuOpen = false">
                    <i class="fa-brands fa-linkedin"></i> {{ contact.linkedInScraped ? 'Refresh LinkedIn' : 'Scrape LinkedIn' }}
                </button>
            </div>
        </div>

        <!-- LinkedIn-style header -->
        <div class="cm-banner" [class.has-bg]="contact.linkedInBackgroundPicStored || contact.linkedInBackgroundPic" [ngStyle]="bannerStyle()"></div>

        <div class="cm-header">
            <div class="cm-avatar" [class.is-placeholder]="!avatarUrl() || avatarFailed">
                <img *ngIf="avatarUrl() && !avatarFailed" [src]="avatarUrl()" [alt]="displayName()" (error)="onAvatarError()" />
                <span *ngIf="!avatarUrl() || avatarFailed">{{ initials() | uppercase }}</span>
            </div>

            <div class="cm-identity">
                <h2>
                    {{ displayName() }}
                    <a *ngIf="contact.linkedInUrl" [href]="contact.linkedInUrl" target="_blank" class="cm-li-link" title="View on LinkedIn">
                        <i class="fa-brands fa-linkedin"></i>
                    </a>
                </h2>
                <div class="cm-headline" *ngIf="contact.linkedInHeadline">{{ contact.linkedInHeadline }}</div>
                <div class="cm-role" *ngIf="contact.position || contact.seniority || contact.department">
                    <span *ngIf="contact.position">{{ contact.position }}</span>
                    <span *ngIf="contact.seniority" class="cm-sep">&middot; {{ contact.seniority }}</span>
                    <span *ngIf="contact.department" class="cm-sep">&middot; {{ contact.department }}</span>
                </div>
                <div class="cm-company" *ngIf="contact.denormProspectName">
                    <i class="fa-solid fa-building"></i> {{ contact.denormProspectName }}
                </div>
                <div class="cm-location" *ngIf="contact.linkedInLocation">
                    <i class="fa-solid fa-location-dot"></i> {{ contact.linkedInLocation }}
                </div>

                <div class="cm-stats" *ngIf="contact.linkedInConnections || contact.linkedInFollowers || contact.linkedInTotalExperienceYears">
                    <span *ngIf="contact.linkedInConnections" class="cm-stat">{{ contact.linkedInConnections | number }} connections</span>
                    <span *ngIf="contact.linkedInFollowers" class="cm-stat">{{ contact.linkedInFollowers | number }} followers</span>
                    <span *ngIf="contact.linkedInTotalExperienceYears" class="cm-stat">{{ contact.linkedInTotalExperienceYears }} yrs experience</span>
                </div>
            </div>
        </div>

        <!-- Contact / action bar -->
        <div class="cm-actions">
            <div class="cm-contact-line" *ngIf="contact.email">
                <i class="fa-solid fa-envelope"></i>
                <a [href]="'mailto:' + contact.email">{{ contact.email }}</a>
                <span class="cm-verify" *ngIf="contact.emailVerified" title="Verified"><i class="fa-solid fa-circle-check"></i></span>
                <span class="cm-verify cm-verify--bad" *ngIf="contact.verificationStatus && !contact.emailVerified">{{ contact.verificationStatus }}</span>
                <button type="button" class="cm-mini" (click)="copyEmail()">{{ copied === 'email' ? 'Copied!' : 'Copy' }}</button>
            </div>
            <div class="cm-contact-line" *ngIf="contact.phone">
                <i class="fa-solid fa-phone"></i>
                <a [href]="telLink()">{{ contact.phone }}</a>
                <a class="cm-phone-action cm-phone-call" [href]="telLink()" title="Call"><i class="fa-solid fa-phone"></i> Call</a>
                <a class="cm-phone-action cm-phone-wa" [href]="whatsAppLink()" target="_blank" title="WhatsApp"><i class="fa-brands fa-whatsapp"></i> WhatsApp</a>
            </div>
            <div class="cm-contact-line" *ngIf="contact.linkedInUrl">
                <i class="fa-brands fa-linkedin"></i>
                <a [href]="contact.linkedInUrl" target="_blank">{{ contact.linkedInUrl }}</a>
            </div>

            <!-- Actions moved to hamburger menu -->

            <!-- Edit form (replaces profile when editing) -->
            <div class="cm-edit-form" *ngIf="editing">
                <label class="cm-field-label">Full Name</label>
                <input type="text" [(ngModel)]="editData.fullName" />
                <label class="cm-field-label">Email</label>
                <input type="email" [(ngModel)]="editData.email" />
                <label class="cm-field-label">Position</label>
                <input type="text" [(ngModel)]="editData.position" />
                <label class="cm-field-label">Phone</label>
                <input type="text" [(ngModel)]="editData.phone" />
                <label class="cm-field-label">LinkedIn URL</label>
                <input type="text" [(ngModel)]="editData.linkedInUrl" />
                <div class="cm-edit-actions">
                    <button type="button" class="cm-primary" (click)="saveEdit()"><i class="fa-solid fa-check"></i> Save</button>
                    <button type="button" (click)="cancelEdit()">Cancel</button>
                </div>
            </div>

            <!-- Tab bar for profile/timeline -->
            <div class="cm-tab-bar" *ngIf="!editing">
                <button [class.active]="activeTab === 'profile'" (click)="activeTab = 'profile'"><i class="fa-solid fa-user"></i> Profile</button>
                <button [class.active]="activeTab === 'timeline'" (click)="activeTab = 'timeline'"><i class="fa-solid fa-clock-rotate-left"></i> Timeline ({{ interactions.length }})</button>
            </div>
        </div>

        <div class="cm-alert" *ngIf="error">{{ error }}</div>

        <div class="cm-body" *ngIf="activeTab === 'profile' && !editing">
            <div class="cm-empty" *ngIf="!contact.linkedInScraped">
                <i class="fa-brands fa-linkedin"></i>
                No LinkedIn profile scraped yet. Use "Scrape LinkedIn" above to pull experience, education and more.
            </div>

            <div class="cm-layout">
                <!-- Main column -->
                <div class="cm-main">
                    <!-- About -->
                    <section class="cm-card" *ngIf="contact.linkedInAbout">
                        <h3>About</h3>
                        <p class="cm-about">{{ contact.linkedInAbout }}</p>
                    </section>

                    <!-- Experience -->
                    <section class="cm-card" *ngIf="contact.linkedInExperiences?.length">
                        <h3><i class="fa-solid fa-briefcase"></i> Experience</h3>
                        <div class="cm-exp" *ngFor="let exp of contact.linkedInExperiences" [class.current]="exp.jobStillWorking">
                            <div class="cm-exp-logo">
                                <img *ngIf="exp.logo" [src]="exp.logo" alt="" />
                                <i *ngIf="!exp.logo" class="fa-solid fa-building"></i>
                            </div>
                            <div class="cm-exp-main">
                                <div class="cm-exp-title">
                                    {{ exp.title }}
                                    <span class="cm-badge" *ngIf="exp.jobStillWorking">Current</span>
                                </div>
                                <div class="cm-exp-company" *ngIf="exp.companyName">{{ exp.companyName }}<span *ngIf="exp.employmentType"> &middot; {{ exp.employmentType }}</span></div>
                                <div class="cm-exp-dates" *ngIf="exp.jobStartedOn || exp.jobEndedOn">
                                    {{ exp.jobStartedOn }}<span *ngIf="exp.jobEndedOn || exp.jobStillWorking"> – {{ exp.jobStillWorking ? 'Present' : exp.jobEndedOn }}</span>
                                </div>
                                <div class="cm-exp-loc" *ngIf="exp.jobLocation">{{ exp.jobLocation }}</div>
                                <p class="cm-exp-desc" *ngIf="exp.jobDescription">{{ exp.jobDescription }}</p>
                            </div>
                        </div>
                    </section>

                    <!-- Education -->
                    <section class="cm-card" *ngIf="contact.linkedInEducations?.length">
                        <h3><i class="fa-solid fa-graduation-cap"></i> Education</h3>
                        <div class="cm-exp" *ngFor="let edu of contact.linkedInEducations">
                            <div class="cm-exp-logo">
                                <img *ngIf="edu.logo" [src]="edu.logo" alt="" />
                                <i *ngIf="!edu.logo" class="fa-solid fa-school"></i>
                            </div>
                            <div class="cm-exp-main">
                                <div class="cm-exp-title">{{ edu.title }}</div>
                                <div class="cm-exp-company" *ngIf="edu.subtitle">{{ edu.subtitle }}</div>
                                <div class="cm-exp-dates" *ngIf="edu.period">{{ edu.period }}</div>
                                <div class="cm-exp-loc" *ngIf="edu.grade">Grade: {{ edu.grade }}</div>
                                <p class="cm-exp-desc" *ngIf="edu.description">{{ edu.description }}</p>
                            </div>
                        </div>
                    </section>

                    <!-- Skills -->
                    <section class="cm-card" *ngIf="contact.linkedInSkills?.length">
                        <h3><i class="fa-solid fa-screwdriver-wrench"></i> Skills</h3>
                        <span class="cm-skill" *ngFor="let s of contact.linkedInSkills">{{ s.title }}</span>
                    </section>
                </div>

                <!-- Sidebar -->
                <div class="cm-side">
                    <section class="cm-card cm-details">
                        <h3>Details</h3>
                        <div class="cm-detail" *ngIf="contact.email">
                            <span class="cm-detail-label">Email</span>
                            <a class="cm-detail-value" [href]="'mailto:' + contact.email">{{ contact.email }}</a>
                        </div>
                        <div class="cm-detail" *ngIf="contact.confidence">
                            <span class="cm-detail-label">Email confidence</span>
                            <span class="cm-detail-value">{{ contact.confidence }}%</span>
                        </div>
                        <div class="cm-detail" *ngIf="contact.emailType">
                            <span class="cm-detail-label">Email type</span>
                            <span class="cm-detail-value">{{ contact.emailType }}</span>
                        </div>
                        <div class="cm-detail" *ngIf="contact.verificationStatus">
                            <span class="cm-detail-label">Verification</span>
                            <span class="cm-detail-value">{{ contact.verificationStatus }}<span *ngIf="contact.verificationScore"> ({{ contact.verificationScore }})</span></span>
                        </div>
                        <div class="cm-detail" *ngIf="contact.phone">
                            <span class="cm-detail-label">Phone</span>
                            <span class="cm-detail-value">
                                <a [href]="telLink()">{{ contact.phone }}</a>
                                <a class="cm-side-icon cm-phone-wa" [href]="whatsAppLink()" target="_blank" title="WhatsApp"><i class="fa-brands fa-whatsapp"></i></a>
                            </span>
                        </div>
                        <div class="cm-detail" *ngIf="contact.seniority">
                            <span class="cm-detail-label">Seniority</span>
                            <span class="cm-detail-value">{{ contact.seniority }}</span>
                        </div>
                        <div class="cm-detail" *ngIf="contact.department">
                            <span class="cm-detail-label">Department</span>
                            <span class="cm-detail-value">{{ contact.department }}</span>
                        </div>
                        <div class="cm-detail" *ngIf="contact.linkedInUrl">
                            <span class="cm-detail-label">LinkedIn</span>
                            <a class="cm-detail-value" [href]="contact.linkedInUrl" target="_blank">View profile</a>
                        </div>
                        <div class="cm-detail" *ngIf="contact.twitter">
                            <span class="cm-detail-label">Twitter</span>
                            <a class="cm-detail-value" [href]="'https://twitter.com/' + contact.twitter" target="_blank">{{ contact.twitter }}</a>
                        </div>
                        <div class="cm-detail" *ngIf="contact.linkedInScrapedAt">
                            <span class="cm-detail-label">LinkedIn scraped</span>
                            <span class="cm-detail-value">{{ contact.linkedInScrapedAt.toDate() | date: 'short' }}</span>
                        </div>
                    </section>

                    <section class="cm-card cm-colleagues" *ngIf="colleagues.length">
                        <h3><i class="fa-solid fa-users"></i> People at {{ contact.denormProspectName || 'this company' }}</h3>
                        <div class="cm-colleague" *ngFor="let col of colleagues" (click)="openColleague(col)">
                            <div class="cm-colleague-avatar" [class.is-placeholder]="!colleagueAvatar(col)">
                                <img *ngIf="colleagueAvatar(col)" [src]="colleagueAvatar(col)" [alt]="colleagueName(col)" />
                                <span *ngIf="!colleagueAvatar(col)">{{ colleagueInitials(col) }}</span>
                            </div>
                            <div class="cm-colleague-main">
                                <div class="cm-colleague-name">{{ colleagueName(col) }}</div>
                                <div class="cm-colleague-pos" *ngIf="col.position">{{ col.position }}</div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>

        <!-- Timeline tab -->
        <div class="cm-timeline-body" *ngIf="activeTab === 'timeline' && !editing">
            <div class="cm-log-form">
                <select [(ngModel)]="newInteraction.type">
                    <option *ngFor="let t of interactionTypes" [value]="t">{{ interactionTypeLabels[t] }}</option>
                </select>
                <input type="text" placeholder="What happened?" [(ngModel)]="newInteraction.summary" (keyup.enter)="logInteraction()" />
                <button type="button" [disabled]="addingInteraction || !newInteraction.summary.trim()" (click)="logInteraction()">
                    <i class="fa-solid" [class.fa-spinner]="addingInteraction" [class.fa-spin]="addingInteraction" [class.fa-plus]="!addingInteraction"></i> Log
                </button>
            </div>
            <div class="cm-empty" *ngIf="!interactions.length">No interactions logged yet.</div>
            <div class="cm-interaction" *ngFor="let i of interactions">
                <div class="cm-interaction-icon"><i [class]="interactionTypeIcons[i.type] || 'fas fa-comment'"></i></div>
                <div class="cm-interaction-body">
                    <div class="cm-interaction-head">
                        <strong>{{ interactionTypeLabels[i.type] || i.type }}</strong>
                        <span class="cm-interaction-date">{{ interactionDate(i) | date: 'short' }}</span>
                    </div>
                    <div>{{ i.summary }}</div>
                    <div class="cm-interaction-email" *ngIf="i.emailSubject">Subject: {{ i.emailSubject }}</div>
                    <div class="cm-interaction-meta" *ngIf="i.denormCreatedByName">By {{ i.denormCreatedByName }}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Intro composer (nested) -->
<div class="cm-composer-overlay" *ngIf="composerOpen && contact" (click)="closeComposer()">
    <div class="cm-composer" (click)="$event.stopPropagation()">
        <button type="button" class="cm-close" (click)="closeComposer()"><i class="fa-solid fa-xmark"></i></button>
        <h2><i class="fa-solid fa-pen-nib"></i> Compose Message</h2>
        <p class="cm-composer-to">To: <strong>{{ displayName() }}</strong> <span *ngIf="contact.email">&lt;{{ contact.email }}&gt;</span></p>

        <label class="cm-field-label">Template</label>
        <select [(ngModel)]="selectedTemplateIdx" (ngModelChange)="applyTemplate($event)">
            <option [ngValue]="-1" disabled>Select a template...</option>
            <option *ngFor="let tpl of templates; let i = index" [ngValue]="i">{{ tpl.name }}</option>
        </select>

        <ng-container *ngIf="draftSubject || draftBody">
            <label class="cm-field-label">Subject
                <button type="button" class="cm-mini-copy" (click)="copyText(draftSubject, 'subject')">{{ copied === 'subject' ? 'Copied!' : 'Copy' }}</button>
            </label>
            <input type="text" [(ngModel)]="draftSubject" />

            <label class="cm-field-label">Body
                <button type="button" class="cm-mini-copy" (click)="copyText(draftBody, 'body')">{{ copied === 'body' ? 'Copied!' : 'Copy' }}</button>
            </label>
            <textarea [(ngModel)]="draftBody" rows="10"></textarea>

            <div class="cm-composer-actions">
                <button type="button" class="cm-copy-full" (click)="copyFull()">
                    <i class="fa-solid fa-copy"></i> {{ copied === 'full' ? 'Copied!' : 'Copy subject + body' }}
                </button>
                <button type="button" class="cm-send-btn" *ngIf="hasSmtp" [disabled]="sending" (click)="sendEmail()">
                    <i class="fa-solid" [class.fa-spinner]="sending" [class.fa-spin]="sending" [class.fa-paper-plane]="!sending"></i>
                    {{ sending ? 'Sending...' : (copied === 'sent' ? 'Sent!' : 'Send Email') }}
                </button>
                <span class="cm-no-smtp" *ngIf="!hasSmtp">
                    <i class="fa-solid fa-info-circle"></i> Add SMTP in Settings to send directly
                </span>
            </div>
        </ng-container>
    </div>
</div>
